export const FILE_EDITOR_THEME_TYPE = {
    IMAGE: 'image',
    VIDEO: 'video',
};

